/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DecimalSeparatorEnum {
    PERIOD = 'PERIOD',
    COMMA = 'COMMA',
}
